import {
  MeasurementPeriodResult,
  MyPageMeasurementsResponse,
} from "@/components/examinee/participation/Types";
import { useExamineeAxios } from "@/utils/axios";
import { useMemo } from "react";

/**
 * マイページ・測定期間の受診者向け API（要ログイン）
 */
export function useMyPageAPI() {
  const axios = useExamineeAxios();
  return useMemo(
    () => ({
      /** マイページ測定一覧取得 API */
      getMeasurements: () =>
        axios.get<MyPageMeasurementsResponse>("/api/mypage/measurements/"),
      /** 測定期間登録 API（毎日問診リマインドも自動生成される。時刻は日付順に 8 件・#1778） */
      registerMeasurementPeriod: (
        sleepCheckupUuid: string,
        startDate: string,
        remindTimes: string[]
      ) =>
        axios.post<MeasurementPeriodResult>("/api/measurement_period/", {
          sleep_checkup_info: sleepCheckupUuid,
          start_date: startDate,
          remind_times: remindTimes,
        }),
    }),
    [axios]
  );
}
